module.exports = __webpack_public_path__ + "static/media/Statua_052.e9e5b2c1.jpg";